import React from 'react';
import {Controller} from 'react-hook-form';
import {useQuery} from 'react-query';
import Select from 'react-select';
import {get} from '../../service/ApiService';
import {Region} from '../../service/Urls';
import {Box, Flex, FormLabel, Text} from '@chakra-ui/react';
import {Group} from '../../constants/client/types';

export default function GroupSelectNew({
  groups,
  control,
  name,
  isReadOnly,
  required,
}: {
  groups: Group[];
  control: any;
  name: string;
  isReadOnly?: boolean;
  required?: boolean;
}) {
  const groupOptions =
    groups?.map(({grGrid, grDesc}) => ({
      value: grGrid,
      label: `${grGrid} - ${grDesc}`,
    })) ?? [];

  return (
    <Controller
      name={name}
      control={control}
      rules={{required}}
      render={({field: {value, onChange, ...rest}, fieldState: {error}}) => {
        return (
          <Flex mx={1}>
            <Box w="100%">
              <FormLabel fontSize="sm" mb="-0.5" ml="1">
                Select Group
              </FormLabel>
              <Select
                {...rest}
                value={groupOptions?.find(group => group.value === value) ?? null}
                onChange={(newValue, actionMeta) => {
                  onChange(newValue?.value, actionMeta);
                }}
                options={groupOptions}
                isDisabled={isReadOnly}
              />

              {error && (
                <Text color="red.400" fontSize="sm">
                  * Group is required
                </Text>
              )}
            </Box>
          </Flex>
        );
      }}
    />
  );
}
